export default __webpack_public_path__ + "static/media/welcome.6cfd2c37.png";